import { Box, Typography } from '@mui/material';
import { GOLD, GOLD2, GOLDF } from '../theme/theme';
import { IMG_LOC_1, IMG_LOC_2, IMG_LOC_3, IMG_LOC_4 } from '../assets/locationRowImages';

const CARDS = [
  { img: IMG_LOC_1, title: 'Scenic Approach',    sub: 'The road in, lined with green' },
  { img: IMG_LOC_2, title: 'Healing Climate',     sub: "Courtallam's fresh mountain air" },
  { img: IMG_LOC_3, title: 'Western Ghats',       sub: 'Surrounded by living green' },
  { img: IMG_LOC_4, title: 'Prime Connectivity',  sub: 'Minutes from Main Falls & Tenkasi' },
];

/**
 * Replaces the previous "Well Planned Layout" panel, which incorrectly
 * displayed a Selangor / Kuala Lumpur (Malaysia) location and GPS
 * coordinates. Rebuilt using the newly attached photos plus a corrected
 * plot-size panel — no incorrect location data anywhere.
 */
export default function LocationRow() {
  return (
    <Box sx={{
      display: 'flex',
      width: '100%',
      gap: '2px',
    }}>
      {CARDS.map((c) => (
        <Box key={c.title} sx={{ position: 'relative', flex: 1.15, aspectRatio: '238 / 128', overflow: 'hidden' }}>
          <Box component="img" src={c.img} alt={c.title} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', display: 'block' }} />
          <Box sx={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            height: '58%',
            background: 'linear-gradient(to top, rgba(0,0,0,0.90) 0%, rgba(0,0,0,0.25) 65%, transparent 100%)',
          }} />
          <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, p: { xs: 0.6, md: 0.9 } }}>
            <Typography sx={{
              fontFamily: "'Cinzel', Georgia, serif",
              fontWeight: 800,
              fontSize: { xs: '8px', md: '10.5px' },
              color: '#fff',
              letterSpacing: '0.02em',
              lineHeight: 1.15,
            }}>
              {c.title}
            </Typography>
            <Typography sx={{ fontSize: { xs: '6.5px', md: '8.5px' }, color: GOLDF, mt: 0.15, display: { xs: 'none', sm: 'block' } }}>
              {c.sub}
            </Typography>
          </Box>
        </Box>
      ))}

      {/* Corrected plot-size panel — no location claim, just the real figures */}
      <Box sx={{
        flex: 0.85,
        aspectRatio: '200 / 128',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
      }}>
        <Typography sx={{
          fontFamily: "'Cinzel', Georgia, serif",
          fontWeight: 700,
          fontSize: { xs: '8px', md: '10px' },
          color: '#fff',
          textAlign: 'center',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          mb: 0.6,
        }}>
          Plot Size Available
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 800, fontSize: { xs: '13px', md: '19px' }, color: GOLDF, lineHeight: 1.1 }}>5</Typography>
            <Typography sx={{ fontSize: { xs: '6px', md: '7.5px' }, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.05em' }}>CENTS</Typography>
          </Box>
          <Box sx={{ width: '1px', height: 20, background: `linear-gradient(${GOLD}, ${GOLD2})` }} />
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 800, fontSize: { xs: '13px', md: '19px' }, color: GOLDF, lineHeight: 1.1 }}>10</Typography>
            <Typography sx={{ fontSize: { xs: '6px', md: '7.5px' }, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.05em' }}>CENTS</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
